import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MetforminAcneComponent } from '@consultation-upsells/metformin/acne/metformin-acne.component';
import { MetforminEdComponent } from '@consultation-upsells/metformin/ed/metformin-ed.component';
import { MetforminHairLossComponent } from '@consultation-upsells/metformin/hair-loss/metformin-hair-loss.component';
import { MetforminComponent } from '@consultation-upsells/metformin/metformin.component';
import { MetforminPeptideComponent } from '@consultation-upsells/metformin/peptide/metformin-peptide.component';
import { MetforminTrtComponent } from '@consultation-upsells/metformin/trt/metformin-trt.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

/**
 * Switcher component that dynamically displays the appropriate Metformin upsell component based on the
 * consultation treatment type.
 */
@Component({
  selector: 'app-metformin-switcher',
  standalone: true,
  imports: [
    CommonModule,
    MetforminComponent,
    MetforminEdComponent,
    MetforminTrtComponent,
    MetforminPeptideComponent,
    MetforminHairLossComponent,
    MetforminAcneComponent,
  ],
  templateUrl: './metformin-switcher.component.html',
})
export class MetforminSwitcherComponent {
  public readonly ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the current treatment type from the consultation storage service.
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
